import {useSelector} from "react-redux";
import {isPending} from "state/selectors/ui";

export function usePending(id, strict) {
    return useSelector(s=>isPending(s, id, strict));
}